import { addRasterOverlay, removeRasterOverlay } from '../raster_helpers';

const airQualityId = 'air-quality';
const pollenId = 'pollen-daily';

const addBreezometerHelper = (map, breezometerId) => {
  addRasterOverlay(
    map,
    breezometerId,
    `https://${breezometerId}.alltrails.com/{z}/{x}/{y}`,
    {
      attribution: "<a target='_blank' href='https://breezometer.com'>BreezoMeter</a>",
      tileSize: 256,
      maxzoom: 16
    },
    {
      paint: {
        'raster-opacity': 0.8
      }
    }
  );
};

const removeBreezometerHelper = (map, id) => {
  removeRasterOverlay(map, id);
};

const addAirQuality = map => {
  addBreezometerHelper(map, airQualityId);
};

const removeAirQuality = map => {
  removeBreezometerHelper(map, airQualityId);
};

const addPollen = map => {
  addBreezometerHelper(map, pollenId);
};

const removePollen = map => {
  removeBreezometerHelper(map, pollenId);
};

export { addAirQuality, addPollen, removeAirQuality, removePollen };
